import React from 'react';
import AdminList from '../Components/Adminlist';
import './pages.css';
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'Home',
    href: '/',
    className: 'breadcrumb-link',
  },
  {
    name: 'Admin',
    href: '',
    isCurrent: true,
    className: 'breadcrumb-current',
  },
];

const Admins = () => {
  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <AdminList />
    </>
  );
};

export default Admins;
